export const FORM_ASSISTANT_GUIDES = [
  {
    id: "form-blueprint",
    title: "Blueprint orientado por prompt",
    summary:
      "Descreva o objetivo do formulário e o assistente gera grupos, campos e validações iniciais alinhadas ao processo.",
    keywords: ["formulario", "assistente", "prompt", "campos", "grupos"],
    promptExamples: [
      "Ficha de onboarding para novos colaboradores com checklist de documentos",
      "Cadastro de fornecedores com dados bancários e homologação",
      "Solicitação de viagem com aprovação do gestor e centro de custo",
    ],
    steps: [
      "Abrir o Assistente IA na tela de formulários e informar o objetivo no campo de prompt.",
      "Revisar os grupos sugeridos e ajustar rótulos antes de enviar para o construtor.",
      "Salvar o resultado em uma nova guia do construtor para finalizar campos e regras.",
    ],
    insights: [
      "Combine prompts curtos com detalhes específicos como anexos obrigatórios ou grupos desejados.",
    ],
  },
  {
    id: "form-document-import",
    title: "Importação guiada por documento",
    summary:
      "Envie PDFs, planilhas ou textos para que a IA extraia campos e opções diretamente do material de origem.",
    keywords: ["documento", "upload", "planilha", "pdf", "extracao"],
    promptExamples: [
      "Gerar formulário a partir do contrato padrão de prestação de serviços",
      "Converter planilha de cadastro de produtos em formulário com listas",
    ],
    steps: [
      "Selecionar um arquivo suportado (PDF, TXT, DOCX ou XLSX) na janela do assistente.",
      "Complementar com observações no prompt quando precisar de campos extras.",
      "Analisar o resumo extraído e abrir o formulário sugerido diretamente no construtor.",
    ],
    insights: [
      "Arquivos extensos são resumidos automaticamente; utilize o preview para validar o conteúdo identificado.",
    ],
  },
  {
    id: "form-refinements",
    title: "Ajustes rápidos",
    summary:
      "Aplique as sugestões do assistente para adicionar campos condizentes com perfis de usuário e etapas do processo.",
    keywords: ["ajustes", "refinamento", "validacao", "tamanho de campo"],
    promptExamples: [
      "Adicionar campos de consentimento LGPD ao formulário de recrutamento",
      "Incluir upload de NF-e e descrição detalhada na solicitação de reembolso",
    ],
    steps: [
      "Gerar a estrutura inicial com o assistente.",
      "Selecionar os campos recomendados adicionais exibidos na prévia.",
      "Aplicar validações sugeridas como obrigatório, lista de opções ou formatos numéricos.",
    ],
    insights: [
      "Os campos listados nas sugestões consideram o histórico da conversa com o assistente do Studio.",
    ],
  },
];
